export default "__VITE_ASSET__C4fLi198__"